//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { FirebaseUI } from "../plugins/firebaseInit";
import firebase from "firebase/app";
import "firebaseui/dist/firebaseui.css";
export default {
  name: "LoginForm",
  data: function data() {
    var vm = this;
    return {
      uiConfig: {
        callbacks: {
          signInSuccessWithAuthResult: function signInSuccessWithAuthResult(authResult) {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            vm.$root.user = authResult.user;
            return true;
          },
          uiShown: function uiShown() {
            // The widget is rendered.
            // Hide the loader.
            console.log("Ui rendered");
          }
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: "popup",
        signInSuccessUrl: "/",
        signInOptions: [// Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID, {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: "PH",
          whitelistedCountries: ["PH", "+63"]
        }],
        // Terms of service url.
        tosUrl: "<your-tos-url>",
        // Privacy policy url.
        privacyPolicyUrl: "<your-privacy-policy-url>"
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      FirebaseUI.start("#auth-container", _this.uiConfig);
    });
  }
};